import type { FileUploadPasteContext, IStickyModelContentsViewHandlers } from './IStickyModelContentsViewHandlers';
import type { Point, Size } from '@view-model/models/common/basic';
import type { PositionDelta } from '@view-model/models/common/types/ui';
import type { ApplicationClipboardPayload } from '@view-model/application/clipboard';
import type { FileContainerId } from 'balus-common';

/* eslint-disable @typescript-eslint/no-unused-vars */
export class NullHandlers implements IStickyModelContentsViewHandlers {
  handleAllElementsSelect(): void {}
  handleAllElementsDeselect(): void {}
  handleArrowKeys(dx: number, dy: number): void {}
  handleDeleteSelectedElements(): void {}
  handleDeleteFileContainer(id: FileContainerId): void {}
  handleResizeFileContainer(id: FileContainerId, positionDelta: PositionDelta, size: Size): void {}
  async handleCutSelectedElements(): Promise<void> {}
  async handleCopySelectedElements(): Promise<void> {}
  async handlePasteClipboardPayload(
    payload: ApplicationClipboardPayload,
    position: Point,
    fileUpload: FileUploadPasteContext
  ): Promise<void> {}
  handleDuplicateSelectedElements(position: Point): void {}
}
/* eslint-enable @typescript-eslint/no-unused-vars */
